import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";

const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/af11efc3-1802-42bd-8de8-7e623c469874/images/a0e3490a3dba3984e7192473a5a34028cb7ecf9a09b8270ba89ab00901212c38.png";

// Sizes + matching border-radius so the rounded mask hides any white corners
// from the source PNG. Filter brightens the dark navy to a cleaner blue.
const sizes = {
  sm: "h-9 w-9 rounded-[10px]",
  md: "h-11 w-11 rounded-xl",
  lg: "h-16 w-16 rounded-[18px]",
  xl: "h-24 w-24 rounded-[26px]",
  "2xl": "h-32 w-32 rounded-[32px]",
};

const textSizes = {
  sm: "text-base",
  md: "text-lg",
  lg: "text-2xl",
  xl: "text-3xl",
  "2xl": "text-4xl",
};

export const Logo = ({ size = "md", showText = true, className = "" }) => {
  const { lang } = useLang();
  return (
    <Link
      to={`/${lang}`}
      data-testid="brand-logo-link"
      className={`flex items-center gap-3 group ${className}`}
    >
      <img
        src={LOGO_URL}
        alt="HolyLand Award"
        className={`${sizes[size]} object-cover`}
        style={{
          filter: "brightness(1.15) saturate(1.05)",
        }}
      />
      {showText && (
        <span
          className={`font-display font-semibold tracking-tight ${textSizes[size]} text-white whitespace-nowrap`}
        >
          HolyLand <span className="brand-text">Award</span>
        </span>
      )}
    </Link>
  );
};

export const BrandWordmark = ({ className = "" }) => (
  <span className={`font-display font-semibold tracking-tight ${className}`}>
    HolyLand <span className="brand-text">Award</span>
  </span>
);

export { LOGO_URL };
